import { ChtmModel } from "../components/chtm/chtm.model"
import { FormyModel } from "../components/formy/formy.model"
import { AskModel } from "../components/ask/ask.model"
import { GridModel, PermitModel } from "../components/grid/grid.model"
import { ChartModel } from "../components/chart/chart.model"
import { CmodalModel } from '../components/cmodal/cmodal.model'
import { CalenModel } from "../components/calen/calen.model";
import { TreevModel } from "../components/treev/treev.model";
import { InfocardModel } from "../components/infocard/infocard.model"

export class PageModel {

    constructor() { }

    id: string
    menu_id: string
    tit: string
    nam: string

    chtms: ChtmModel[]
    frms: FormyModel[]
    asks: AskModel[]
    grds: GridModel[]
    prm_grds_dep: PermitModel[]
    charts: ChartModel[]
    calens: CalenModel[]
    trvs: TreevModel[]
    infocards: InfocardModel[]

    vis: boolean // (true).visible, false.hidden
}

export class PagesumModel {
    dis: string
    mdl: any // model with typ
}